import { render } from "./BoleteriaPage.vue?vue&type=template&id=5a28a5a0&scoped=true"
import script from "./BoleteriaPage.vue?vue&type=script&lang=js"
export * from "./BoleteriaPage.vue?vue&type=script&lang=js"

import "./BoleteriaPage.vue?vue&type=style&index=0&id=5a28a5a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a28a5a0"]])

export default __exports__